import { Component, OnInit, OnChanges, ViewChild, ElementRef, Input, Output, EventEmitter, AfterViewInit } from '@angular/core';
import { NetworkService } from '../network.service';
import { Router } from '@angular/router';
import { VcaAlertsService } from './../../../../../../common/vca-alerts';
import { NgForm } from '@angular/forms';
import  { IpValidationUtils  } from './../../../../../../common/validations/ip-validation-utils';
import { Comparator, StringFilter } from '@clr/angular';

const _ = require('lodash');

class NameFilter implements StringFilter<string> {
    accepts(row: any, search: string): boolean {
        let name: string = row.name;
        return name.toLowerCase().indexOf(search) >= 0;
    }
}
@Component({
    selector: 'associate-vc-dialog',
    template: require('./associate-vc-dialog.html'),
    styles: [require('../../networking-view.scss')]
})

export class AssociateVcDialog implements OnChanges{
    @Input() showDialog: boolean;
    @Input() dialogData: any;
    @Input() vcId: string;
    @Input() backingList: any;
    @Input() backingSelectedRows: any;
    @Input() canSelectVirtualWire: boolean = false;
    @Output('cancel') cancelEventEmitter = new EventEmitter();
    @Output('save') saveEventEmitter = new EventEmitter();

    private selectedDVPG:  {};
    private selectedVirtualWire: {};
    private isLoading: boolean = false;
    private nameFilter = new NameFilter();
    constructor(private networkService: NetworkService) {
       this.resetSelection();
    }

    resetSelection() {
        this.selectedDVPG = {};
        this.selectedVirtualWire = {};
    }
    ngOnChanges() {
        if (!this.showDialog) {
            return;
        }
        this.resetSelection();
        this.getNetworkBackings();
    }

    highlightSelectedRows() {
        if (!this.backingList || this.backingList.length === 0 || !this.backingSelectedRows) {
            return;
        }
        var __this  = this;
        if (this.dialogData && this.dialogData.backings && this.dialogData.backings.length > 0) {
            let editBacking = this.dialogData.backings;
            editBacking.forEach(function(item) {
                if (item.type === 'DVPG') {
                    __this.backingList.dvpgs.unshift ({
                         "entity_id": item['backingId'],
                         "vcenter_instanceId": item['vCenterInstanceUuid'],
                         "name": item['backingName'],
                         "config": {
                             "distributedVirtualSwitch": item['distributedVirtualSwitch'] ? item['distributedVirtualSwitch'] : {}
                         }
                     })
                } else if (item.type === 'virtualwire') {
                    __this.backingList.virtualwires.unshift ({
                        "entity_id": item['objectId'],
                        "vcenter_instanceId": item['vCenterInstanceUuid'],
                        "name": item['backingName']
                    })
                }
            })
        }

        var selectedRow = this.backingSelectedRows;
        var selectedRow;
        this.backingSelectedRows.forEach(function(row) {
            if (row.vcenter_instanceId === __this.vcId) {
                selectedRow = row;
                return;
            }
        });

        if (selectedRow) {
            this.selectedDVPG = [];
            this.selectedVirtualWire = [];
            if (selectedRow.backings.dvpgs && selectedRow.backings.dvpgs.length > 0) {
                this.backingList.dvpgs.forEach(function(allDVPG) {
                    selectedRow.backings.dvpgs.forEach(function(selectedDVPG) {
                        if (allDVPG.entity_id === selectedDVPG.entity_id)
                        __this.selectedDVPG = allDVPG
                    });
                })
            }

            if (selectedRow.backings.virtualwires && selectedRow.backings.virtualwires.length > 0) {
                this.backingList.virtualwires.forEach(function(allVirtualWire) {
                    selectedRow.backings.virtualwires.forEach(function(selectedVirtualWire) {
                        if (allVirtualWire.objectId === selectedVirtualWire.objectId)
                        __this.selectedVirtualWire = allVirtualWire
                    });
                })
            }
        }
    }

    cancel() {
        if (this.cancelEventEmitter) {
            this.cancelEventEmitter.emit();
         }
         this.showDialog = false;
    }

    save(formData) {
        this.showDialog = false;
        this.saveEventEmitter.emit({
            vcId: this.vcId,
            selectedDVPG: [this.selectedDVPG],
            selectedVirtualWire: [this.selectedVirtualWire]
        });
    }

    // When Select link is clicked
    getNetworkBackings() {
        this.backingList = [];
        this.isLoading = true;
        this.networkService.getNetworkBackings(this.vcId)
            .subscribe(
                data => {
                    this.backingList = data;
                    this.isLoading = false;
                    this.highlightSelectedRows();
                },
                error => {
                    console.log ("Error backing")
                    this.isLoading = false;
                }
            );
    }
   
}



// WEBPACK FOOTER //
// ./src/app/modules/networking/networking-vc/networks/import-network/associate-vc-dialog-component.ts